// extracted by mini-css-extract-plugin
module.exports = {"rootArea":"TopicSectionEditingPage_rootArea__1EV7x","managingArea":"TopicSectionEditingPage_managingArea__1ZT-V"};